import { render, staticRenderFns } from "./acceptanceAdd.vue?vue&type=template&id=2b0b5d95&scoped=true"
import script from "./acceptanceAdd.vue?vue&type=script&lang=js"
export * from "./acceptanceAdd.vue?vue&type=script&lang=js"
import style0 from "./acceptanceAdd.vue?vue&type=style&index=0&id=2b0b5d95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b5d95",
  null
  
)

export default component.exports